import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { IReportsSearchService } from './custom-report/custom-report-search.service';
import { ReportTemplateClient, ReportTemplateView, SearchReportTemplateParameters } from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class ReportTemplateService implements IReportsSearchService<ReportTemplateView> {
    constructor(private readonly client: ReportTemplateClient) {}

    async searchReports(body: SearchReportTemplateParameters): Promise<ReportTemplateView[]> {
        const reportNames = [
            'Sales Leads',
            'Estimates Bid',
            'Estimates Awarded',
            'Opportunities',
            'Buildings',
            'Companies',
            'Change Orders',
            'Awarded Final Estimates',
            'Service Modules',
            'Sales Projects',
            'Accounts',
            'Service Terms',
            'Service Category Costs',
            'Service Subcategory Costs',
            'Service Costs',
            'Service Module Subcontractor',
            'Service Module Expenses',
            'Project Module Subcontractor',
            'Project Module Expenses',
            'Point List Systems',
            'Competing Bidders'
        ];
        const crmReports = await lastValueFrom(this.client.reportTemplateSearchReportTemplates(body));
        return crmReports.filter((r) => reportNames.includes(r.name ?? ''));
    }

    async getByRoute(filterText: string): Promise<ReportTemplateView> {
        return await lastValueFrom(this.client.reportTemplateGetByRoute(filterText));
    }

    async toggleFavorite(id: number): Promise<boolean> {
        return await lastValueFrom(this.client.reportTemplateToggleFavorite(id));
    }
}
